<template>
  <div class="well container" :class="cart_update_status" id="well_cart_view" sticky-class="cartSticky">
    <div class="well123">
      <div class="heading1">
        <span><i class="fa fa-shopping-basket" style="font-size: 20px !important; font-weight: bold !important"
            aria-hidden="true"></i>
          : {{ cartItemCount }} ITEMS</span>
        <span>{{ currency_symbol }}.
          {{ Math.round((cartTotalPrice + Number.EPSILON) * 100) / 100 }}
          <a class="close_cart" @click="closeCart">X</a></span>
      </div>
      <!-- <div ng-repeat="item in itemcart">
               </div> -->
      <div class="cart_containt_item">
        <div v-if="cartItemCount <= 0" class="additemtocart">
          <img :src="empty_cart" style="width: 250px; height: auto" alt="" />
        </div>
        <div class="cart_items" v-for="item in cartItems" :key="item.item_id">
          <div class="description_item">
            <span v-if="item.item.items.addon_optgrp_price == 0">
              {{ item.item.items.title }}
            </span>

            <span v-else> {{ item.item.items.add_opt_title }} </span>
          </div>
          <div class="quantity_item">
            <button class="btn btn-warning btn-xs" type="button" name="button"
              style="background-color: #ffbb0e; color: #fff" @click="
                deleteFromCart(
                  item.item.items.item_id,
                  item.item.items.title,
                  item.item.items
                )
              ">
              <i class="fa fa-minus" aria-hidden="true"></i>
            </button>

            <span style="width: 30px; padding: 5px" id="qty">{{ item.quantity }}
            </span>
            <button class="btn btn-warning btn-xs" type="button" name="button"
              style="background-color: #ffbb0e; color: #fff" @click="addToCart(item.item.items)">
              <i class="fa fa-plus" aria-hidden="true"></i>
            </button>
          </div>

          <span v-if="item.item.items.addon_optgrp_price == 0">
            <div class="total-price_item" v-if="item.item.items.discounted_price == 0">
              {{ currency_symbol }}.
              {{ item.item.items.sale_price * item.quantity }}
              <a style="color: #0056b3" class="h6 mb-2" @click.prevent="
                removeProductFromCart(
                  item.item.items.item_id,
                  item.item.items.title,
                  item.item.items
                )
              ">
                <b-icon-x-square style="float: right; margin-top: 5px" variant="dark"></b-icon-x-square>
              </a>
            </div>

            <div class="total-price_item" v-if="item.item.items.discounted_price > 0">
              {{ currency_symbol }}.
              {{ item.item.items.discounted_price * item.quantity }}
              <a style="color: #0056b3" class="h6 mb-2" @click.prevent="
                removeProductFromCart(
                  item.item.items.item_id,
                  item.item.items.title,
                  item.item.items
                )
              ">
                <b-icon-x-square style="float: right; margin-top: 5px" variant="dark"></b-icon-x-square>
              </a>
            </div>
          </span>

          <span v-else>
            <div class="total-price_item" v-if="item.item.items.discounted_price == 0">
              {{ currency_symbol }}.
              {{ item.item.items.addon_optgrp_price * item.quantity }}
              <a style="color: #0056b3" class="h6 mb-2" href="#" @click.prevent="
                removeProductFromCart(
                  item.item.items.item_id,
                  item.item.items.title,
                  item.item.items
                )
              ">
                <b-icon-x-square style="float: right; margin-top: 5px" variant="dark"></b-icon-x-square>
              </a>
            </div>
            <div class="total-price_item" v-if="item.item.items.discounted_price > 0">
              {{ currency_symbol }}.
              {{ item.item.items.addon_optgrp_price * item.quantity }}
              <a style="color: #0056b3" class="h6 mb-2" href="#" @click.prevent="
                removeProductFromCart(
                  item.item.items.item_id,
                  item.item.items.title,
                  item.item.items
                )
              ">
                <b-icon-x-square style="float: right; margin-top: 5px" variant="dark"></b-icon-x-square>
              </a>
            </div>
          </span>

          <div class="clearfix"></div>
        </div>
      </div>

      <div class="input-group discountcode" v-if="
        cartItemCount > 0 &&
        ((digital_order_setting.promo_code_on_delivery == 1 &&
          getOrderType === 'delivery') ||
          (digital_order_setting.promo_code_on_dinein == 1 &&
            getOrderType === 'dinein') ||
          (digital_order_setting.promo_code_on_pickup == 1 &&
            getOrderType === 'pickup'))
      ">
        <!--
                 <b-form-input 
                 v-if="applied_promo_disc_amt == 0"
                 class="form-control"
                v-model="promo_code_ent" 
                id="usernote" 
                placeholder="Enter Promo Code"
                type="text">
                </b-form-input>




               
               <div v-if="applied_promo_disc_amt == 0" class="input-group-btn" >
                  
                  
                  <button @click="applyPromoCode" class="btn btn-warning" type="submit" style="background-color: #ffbb0e;border-color: #ffbb0e;">
                  Apply
                  </button>
               </div>-->

        <!--  <div
          v-if="applied_promo_disc_amt == 0"
          @click="showPromoCode"
          role="button"
          aria-label="Apply Coupon"
          class="show_promo_code_btn"
        >
          <span style="margin-right: 10px" class="fa-stack fa-lg">
            <i class="fa fa-certificate fa-stack-2x"></i>
            <i class="fa fa-tag fa-stack-1x fa-inverse"></i>
          </span>
          Apply Promo Code
        </div> -->

        <div v-if="getCoupanAmount != 0">
          <!--   <b-icon-check-circle-fill style="float:left;font-size:15px; color:#343a40;margin:5px"></b-icon-check-circle-fill> 
                                     <span style="float:left; margin-left:-9px; font-size:15px; color:#343a40"> {{coupon_code_name}} - Applied Successfully  {{currency_symbol}}. {{applied_promo_disc_amt}} <a style="margin-left: 20px;" @click="removePromoCode">
                                                <b-icon-x-circle-fill 
                                         
                                         style="color:red">
                                            </b-icon-x-circle-fill>
                                         </a></span>-->

          <div class="_2eFfS">
            <div class="_2ksRx">
              <div class="_2CuZt">{{ getCoupanName }}</div>
              <div class="jO5AL">
                Applied Successfully {{ currency_symbol }}.
                {{ getCoupanAmount }}
              </div>
            </div>
            <span role="button" @click="removePromoCode" aria-label="Remove" class="_1cXUn">Remove</span>
          </div>
        </div>
      </div>
      <div class="cart_total">
        <div class="total_cart_value" v-if="cartItemCount > 0">
          <span>Total</span>
          <span>{{ currency_symbol }}.
            {{
                Math.round(
                  (cartTotalPrice - applied_promo_disc_amt + Number.EPSILON) * 100
                ) / 100
            }}</span>
        </div>
        <div class="empty_cart" v-if="cartItemCount > 0">
          <a @click.prevent="clearCartItems()">
            <b-icon-trash-fill variant="danger"></b-icon-trash-fill> Empty
            cart
          </a>
        </div>
        <input v-if="cartItemCount == 0" @click="gotoCheckout" type="submit" name="submit" class="btnsubmit"
          value="PROCEED TO CHECKOUT" disabled />

        <input v-if="cartItemCount > 0" @click="gotoCheckout" type="submit" name="submit" class="btnsubmit"
          value="PROCEED TO CHECKOUT" />
      </div>
    </div>

    <b-sidebar id="sidebar-right" ref="sidebar" right shadow>
      <div class="px-3 py-2">
        <div v-if="viewAllPromoCode.length > 0" style="padding-left: 20px; padding-right: 20px; width: auto" class="">
          <div class="_1L8WG">
            <span class="SSFcO icon-close"></span>
            <div class="_2Joay"></div>
          </div>
          <div class="Dm4hT">
            <div class="_3Um38 null">
              <input class="_381fS _1oTLG _2x3kD" type="text" name="" placeholder="Enter Promo Code" maxlength="50"
                v-model="promo_code_ent" />
              <div class="_2EeI1 _26LFr"></div>
              <label class="_1Cvlf _2tL9P"></label>
            </div>

            <button @click="applyPromoCode(promo_code_ent)" class="_3HIZ1 _3keqX">
              Apply
            </button>
          </div>
        </div>

        <div style="padding-left: 20px; padding-right: 20px; width: auto">
          <div v-if="viewAllPromoCode.length > 0" class="_3sxJM">
            <h2 class="_1aSpx">Available Promo Codes</h2>

            <div v-for="(promocode, index) in viewAllPromoCode" :key="index">
              <div class="_1p3XG">
                <div class="_1hryr">
                  <div class="KVykS -QmN-">
                    <div>
                      <div>
                        <div class="_3x0ey">
                          <div class="_2fpj9 _2Vb6W">
                            <span class="_2prG7">
                              {{ promocode.coupan_code }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="v0d5B">{{ promocode.coupon_code_title }}</div>
                    <div class="mFwvW">{{ promocode.description }}</div>
                    <div class="mFwvW">
                      Valid Till: {{ convertDate(promocode.expires_on) }}
                    </div>
                    <button @click="applyPromoCode(promocode.coupan_code)" class="_3dmIW _1KzVF">
                      APPLY
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-else class="_3sxJM">
            <h2 class="_1aSpx">No Promo Code Available</h2>
          </div>
        </div>
      </div>
    </b-sidebar>
  </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import Footer from "./Footer";
import Header from "./Header";

import empty_cart from "../assets/emptycart.svg";
import moment from "moment";

export default {
  name: "Cart",
  mixins: [Header, Footer],
  computed: {
    ...mapGetters(["cartItems"]),
    ...mapGetters(["outletInformation"]),
    ...mapGetters(["getOrderType"]),
    ...mapGetters(["cartGST"]),
    ...mapGetters(["additionalCharges"]),
    ...mapGetters(["getAdditionalCharges"]),
    ...mapGetters(["cartTotalPrice"]),
    ...mapGetters(["cartItemCount"]),
    ...mapGetters(["currency_symbol"]),
    ...mapGetters(["digital_order_setting"]),
    ...mapGetters(["cart_update_status"]),
    ...mapGetters(["viewAllPromoCode"]),
    ...mapGetters(["getCoupanName"]),
    ...mapGetters(["getCoupanAmount"]),

    ...mapGetters(["getCoupanID"]),
    ...mapGetters(["getCoupanType"]),
  },
  data () {
    return {
      itemQty: 0,
      mainProps: { width: 75, height: 75, class: "m1" },
      deliverytype: localStorage.getItem("deliverytype"),
      usernote: "",
      userinfolocal: localStorage.getItem("userinfo")
        ? JSON.parse(localStorage.getItem("userinfo"))
        : [],
      pay_option: "cash",
      pay_methods: [],
      promo_code_ent: "",
      applied_promo_disc_amt: 0,
      coupon_code_name: "",
      coupon_code_type: "",
      coupan_code_id: "",
      coupan_code_amt: 0,
      table_room_no: "",
      empty_cart,
      promocodes: [],
      boxTwo: "",
      currentItemCount: 0,
    };
  },
  methods: {
    ...mapActions(["getMenuItems"]),
    ...mapActions(["getAllPromoCode"]),
    checkPromoCodeValidity (from_date_time, to_date_time) {
      var current = moment();
      var compare = this.convertDateForPromo(current);

      var bool2 = moment(compare).isBetween(
        this.convertDateForPromo(from_date_time),
        this.convertDateForPromo(to_date_time)
      ); // false

      //var bool3 = moment("2010-10-28").isBetween(this.convertDateForPromo("2010-10-20"), this.convertDateForPromo("2010-10-25")); // false

      //alert("bool3 "+bool3)
      //alert("Same "+moment('2019-11-11').isSame('2019-11-11'))

      return bool2;
    },
    checkPromoStartDateSame (from_date_time) {
      var current = moment();
      var compare = this.convertDateForPromo(current);

      // alert("compare ", this.convertDateForPromo(current));
      // alert("from_date_time ", from_date_time);
      var bool2 = moment(compare).isSame(from_date_time);

      // var bool3 = moment("2010-10-28").isBetween(this.convertDateForPromo("2010-10-20"), this.convertDateForPromo("2010-10-25")); // false

      //alert("bool3 "+bool3)
      //alert("Same "+moment('2019-11-11').isSame('2019-11-11'))

      return bool2;
    },
    checkPromoEndDateSame (to_date_time) {
      var current = moment();
      var compare = this.convertDateForPromo(current);

      var bool2 = moment(compare).isSame(to_date_time);

      // var bool3 = moment("2010-10-28").isBetween(this.convertDateForPromo("2010-10-20"), this.convertDateForPromo("2010-10-25")); // false

      //alert("bool3 "+bool3)
      //alert("Same "+moment('2019-11-11').isSame('2019-11-11'))

      return bool2;
    },
    showPromoCode () {
      //this.$bvModal.show('modal-center-order-type')

      //this.$bvSidebar.show('sidebar-right')

      this.getAllPromoCode();
      this.$root.$emit("bv::toggle::collapse", "sidebar-right");
      /*  let currentObj = this;
      setTimeout(function () {
        //alert();

        if (currentObj.viewAllPromoCode.length > 0) {
          
        } else {
          currentObj.$bvToast.toast(`Sorry !!! No Promo Code Available`, {
            variant: "danger",
            toaster: "b-toaster-bottom-left",
            solid: true,
            autoHideDelay: 2000,
          });
        }
      }, 100); */

      //alert(JSON.stringify(this.viewAllPromoCode))
    },
    getPromoCode () {
      let store_id;
      this.outletInformation.find((outlet) => {
        store_id = outlet.store_id;
      });

      // alert(store_id)

      let currentObj = this;

      currentObj.axios
        .get("promos?store_id=" + store_id)
        .then(function (response) {
          let status = JSON.stringify(response.data.status);

          //   alert(status)

          if (status == 200) {
            currentObj.promocodes = response.data.promocodes;

            // alert(JSON.stringify(response.data.promocodes))
          }
        })
        .catch((error) => {
          //this.errorMessage = error.message;
          // alert("There was an error! "+ error);

          console.log(error);
        });
    },
    filterChangedPay (value) {
      //  alert(value)

      this.pay_option = value;
    },
    filterChanged (value) {
      // alert(value)
      // alert('delivery type in local storage '+ localStorage.getItem('deliverytype'))
      this.$store.dispatch("saveOrderType", {
        ordertype: value,
      });

      this.outletInformation.find((outlet) => {
        let pay = outlet.digital_ordering_settings.pay_gateway[value];
        // console.log("Options are "+JSON.stringify(pay))

        this.pay_methods = [];
        pay.find((opt) => {
          if (opt.active == 1)
            this.pay_methods.push({
              text: opt.key,
              value: opt.key,
            });
        });
      });

      if (value !== "dinein") {
        this.table_room_no = "";
      }
      //  console.log("Payment Options are "+JSON.stringify(this.pay_methods))

      /*
                this.pay_option.push({
                    text:'Toggle this custom radio',
                    value: 'first'
                })*/

      localStorage.setItem("deliverytype", this.deliverytype);
    },
    placeOrder () {
      // alert("Hello")

      let reason = "";
      let storeId = this.userinfolocal.store_id;
      let custName = this.userinfolocal.name;
      let phone = this.userinfolocal.phone;
      let email = "";
      let line1 = this.userinfolocal.address_line1;
      let line2 = "";

      /* console.log("reason "+ reason)
            console.log("storeId "+ storeId)
            console.log("custName "+ custName)
            console.log("phone "+ phone)
            console.log("email "+ email)
            console.log("line1 "+ line1)
            console.log("line2 "+ line2)*/

      let orderLevelDiscount = 0.0;
      let deliveryType = localStorage.getItem("deliverytype");
      let instructions = this.usernote;
      let quantity = 1;

      let orderState = "placed";
      let orderSubtotal = this.cartTotalPrice;

      let order_level_charges = 0.0;

      let order_charges = [];

      this.getAdditionalCharges.forEach((item) => {
        order_level_charges = item.total;
        //  let title = item.title
        order_charges.push({
          title: item.charge_name,
          value: item.total,
          perOrFixed: item.per_or_fixed,
          store_id: storeId,
        });
      });

      //console.log("order_charges "+JSON.stringify(order_charges))
      let orderLevelTotalTaxes = this.cartGST.cgst + this.cartGST.sgst;
      let orderLevelTotalCharges = order_level_charges;

      let orderTotal;
      let total_item_charge = 0;
      let currentObj = this;
      currentObj.cartItems.find((items) => {
        if (items.add_charge.length > 0) {
          total_item_charge =
            total_item_charge + items.add_charge[0].calculated_charge_amt;
        }
      });

      if (this.cartGST.tax === "Incl.") {
        orderTotal =
          this.cartTotalPrice +
          order_level_charges -
          this.applied_promo_disc_amt;
      } else {
        orderTotal =
          this.cartTotalPrice +
          this.cartGST.cgst +
          this.cartGST.sgst +
          order_level_charges -
          this.applied_promo_disc_amt;
      }

      var m = new Date();
      var dateString =
        m.getUTCFullYear() +
        "-" +
        (m.getUTCMonth() + 1) +
        "-" +
        m.getUTCDate() +
        " " +
        m.getUTCHours() +
        ":" +
        m.getUTCMinutes() +
        ":" +
        m.getUTCSeconds();
      let orderDateTime = dateString;

      let table_no = this.table_room_no;
      let room_no = this.table_room_no;

      let currency = "";

      this.outletInformation.forEach((item) => {
        currency = item.currency_code;
      });

      //console.log("orderLevelTotalCharges "+ orderLevelTotalCharges)
      /*console.log("orderLevelDiscount "+ orderLevelDiscount)
            console.log("deliveryType "+ deliveryType)
            console.log("instructions "+ instructions)
            console.log("quantity "+ quantity)
            
            console.log("orderLevelTotalTaxes "+ orderLevelTotalTaxes)
            console.log("orderState "+ orderState)
            console.log("orderSubtotal "+ orderSubtotal)
            console.log("orderTotal "+ orderTotal)
            console.log("orderDateTime "+ orderDateTime)
            console.log("table_no "+ table_no)
            console.log("room_no "+ room_no)
            console.log("currency "+ currency)*/

      // alert(this.pay_option)

      let paygateway_type = 0;

      if (this.pay_option == "cash") {
        paygateway_type = 0;
      } else if (this.pay_option == "cod") {
        paygateway_type = 3;
      }
      let digi_order_type = 0;
      let order_later_datetime = "";

      /*
                applied_promo_disc_amt:0,
                coupon_code_name:'',
                coupon_code_type:'',
                coupan_code_id:'',
                coupan_code_amt:0
            */
      let coupon = this.coupon_code_name;
      let couponDisounttotal = this.applied_promo_disc_amt;
      let couponDisount = this.coupan_code_amt;
      let couponDisounttype = this.coupon_code_type;
      let code_id = this.coupan_code_amt;
      let cust_lat = 0.0;
      let cust_lng = 0.0;

      /* console.log("paygateway_type "+ paygateway_type)
            console.log("digi_order_type "+ digi_order_type)
            console.log("order_later_datetime "+ order_later_datetime)
            console.log("coupon "+ coupon)
            console.log("couponDisounttotal "+ couponDisounttotal)
            console.log("couponDisount "+ couponDisount)
            console.log("couponDisounttype "+ couponDisounttype)
            console.log("code_id "+ code_id)
            console.log("cust_lat "+ cust_lat)
            console.log("cust_lng "+ cust_lng)*/

      let place_order = {};
      let order_items = [];
      let order_payments = [];

      order_payments.push({
        payment_option: this.pay_option,
        amount: orderTotal,
        store_id: storeId,
      });

      //  console.log("cartItems are "+JSON.stringify(this.cartItems))

      this.cartItems.find((items) => {
        //  console.log("sale_price is "+items.item.items.sale_price)
        //  console.log("quantity is "+JSON.stringify(items.quantity))

        order_items.push({
          title: items.item.items.title,
          item_id: items.item.items.item_id,
          food_type: items.item.items.food_type,
          price: items.item.items.sale_price,
          quantity: items.item.quantity,
          total: items.item.items.sale_price * items.quantity,
          total_with_tax: items.item.quantity,
          tax_per: items.item.items.tax_per,
          tax_value: items.item.items.tax_value,
          product_group_id: items.item.items.product_group,
          is_devidable: items.item.items.is_devidable,
          item_note: "make it spicy",
          order_child_options: [],
        });
      });

      place_order = {
        reason: reason,
        storeId: storeId,
        custName: custName,
        phone: phone,
        email: email,
        line1: line1,
        line2: line2,
        orderLevelDiscount: orderLevelDiscount,
        deliveryType: deliveryType,
        instructions: instructions,
        quantity: quantity,
        orderLevelTotalCharges: orderLevelTotalCharges,
        orderLevelTotalTaxes: orderLevelTotalTaxes,
        orderState: orderState,
        orderSubtotal: orderSubtotal,
        orderTotal: orderTotal,
        orderDateTime: orderDateTime,
        table_no: table_no,
        room_no: room_no,
        currency: currency,
        paygateway_type: paygateway_type,
        digi_order_type: digi_order_type,
        order_later_datetime: order_later_datetime,
        coupon: coupon,
        couponDisounttotal: couponDisounttotal,
        couponDisount: couponDisount,
        couponDisounttype: couponDisounttype,
        code_id: code_id,
        cust_lat: cust_lat,
        cust_lng: cust_lng,
        order_items,
        order_payments,
        order_charges,
      };

      console.log("order_items " + JSON.stringify(place_order));
    },
    applyPromoCode (promocode) {
      //alert(JSON.stringify(this.userinfolocal));
      //  alert(JSON.parse(localStorage.getItem('userinfo')))

      //  if(this.userinfolocal != null || JSON.parse(localStorage.getItem('userinfo')) != null)
      if (
        this.userinfolocal != "" ||
        JSON.parse(localStorage.getItem("userinfo")) != null
      ) {
        //alert(this.userinfolocal)

        this.promo_code_ent = promocode;
        let promo_code = {};

        if (this.promo_code_ent == "" || this.promo_code_ent == undefined) {
          this.$bvToast.toast("Please enter valid promo code", {
            variant: "danger",
            toaster: "b-toaster-bottom-left",
            solid: true,
          });

          return;
        }

        this.userinfolocal = JSON.parse(localStorage.getItem("userinfo"));

        let storeId = this.userinfolocal.store_id;
        let custType = this.userinfolocal.cust_type;
        let phone = this.userinfolocal.phone;
        let order_amt = this.cartTotalPrice;
        let coupon = this.promo_code_ent;

        promo_code = {
          store_id: storeId,
          coupon: coupon,
          order_amt: order_amt,
          cust_phone: phone,
          cust_type: custType,
        };

        //  alert(JSON.stringify(promo_code));

        let currentObj = this;

        this.axios
          .post("applypromo", promo_code)
          .then(function (response) {
            let status = JSON.stringify(response.data.status);

            if (status === "204") {
              currentObj.$bvToast.toast(response.data.msg, {
                variant: "danger",
                toaster: "b-toaster-bottom-left",
                solid: true,
              });
            }

            if (status === "200") {
              //  currentObj.$bvModal.hide('modal-sm')

              currentObj.$bvToast.toast("Promo code applied successfully", {
                variant: "success",
                toaster: "b-toaster-bottom-left",
                solid: true,
              });

              /* per_fixed = 1 then per, per_fixed = o then fixed */
              currentObj.coupon_code_name = response.data.msg.coupan_code;
              //console.log("coupon code is "+currentObj.coupon_code)
              currentObj.coupon_code_type = response.data.msg.per_fixed;
              let promo_amt = response.data.msg.amount;
              currentObj.coupan_code_id = response.data.msg.code_id;
              currentObj.coupan_code_amt = JSON.parse(
                response.data.msg.amount
              ).toFixed(2);

              //alert("currentObj.coupan_code_amt "+currentObj.coupan_code_amt )

              if (currentObj.coupon_code_type == 0) {
                //   alert("if promo_amt "+promo_amt)
                currentObj.applied_promo_disc_amt = promo_amt;

                // alert("currentObj.applied_promo_disc_amt "+currentObj.applied_promo_disc_amt )
              } else if (currentObj.coupon_code_type == 1) {
                //alert("else promo_amt "+promo_amt)
                currentObj.applied_promo_disc_amt = (
                  Math.round(
                    ((currentObj.cartTotalPrice / 100) * promo_amt +
                      Number.EPSILON) *
                    100
                  ) / 100
                ).toFixed(2);
              }

              let total_item_charge = 0;

              if (currentObj.cartGST.tax === "Incl.") {
                // console.log("If block")

                currentObj.cartItems.find((items) => {
                  if (items.add_charge.length > 0) {
                    total_item_charge =
                      total_item_charge +
                      items.add_charge[0].calculated_charge_amt;
                  }
                });

                //console.log("total_item_charge is "+total_item_charge)

                let total_after_minus_promo =
                  currentObj.cartTotalPrice -
                  total_item_charge -
                  currentObj.applied_promo_disc_amt;

                let tempgst =
                  (total_after_minus_promo / 100) * currentObj.cartGST.gstper;

                // console.log("total_after_minus_promo "+total_after_minus_promo)
                // console.log("tempgst "+tempgst)

                let temp_total_incl_gst = total_after_minus_promo - tempgst;

                let gstcal =
                  (temp_total_incl_gst / 100) * currentObj.cartGST.gstper;
                currentObj.cartGST.cgst =
                  Math.round((gstcal / 2 + Number.EPSILON) * 100) / 100;
                currentObj.cartGST.sgst =
                  Math.round((gstcal / 2 + Number.EPSILON) * 100) / 100;
              } else if (currentObj.cartGST.tax === "Excl.") {
                console.log("else block");

                currentObj.cartItems.find((items) => {
                  if (items.add_charge.length > 0) {
                    total_item_charge =
                      total_item_charge +
                      items.add_charge[0].calculated_charge_amt;
                  }
                });

                //  console.log("total_item_charge is "+total_item_charge)

                /*  console.log(
                  "applied_promo_disc_amt is " +
                    currentObj.applied_promo_disc_amt
                ); */
                let gstcal =
                  ((currentObj.cartTotalPrice -
                    total_item_charge -
                    currentObj.applied_promo_disc_amt) /
                    100) *
                  currentObj.cartGST.gstper;
                console.log("gst is " + gstcal);
                currentObj.cartGST.cgst =
                  Math.round((gstcal / 2 + Number.EPSILON) * 100) / 100;
                currentObj.cartGST.sgst =
                  Math.round((gstcal / 2 + Number.EPSILON) * 100) / 100;
              }

              console.log(
                "last cartGST is " + JSON.stringify(currentObj.cartGST)
              );

              currentObj.$store.dispatch("saveCoupanCodeName", {
                coupon_code_name: currentObj.coupon_code_name,
              });
              currentObj.$store.dispatch("saveCoupanCodeAmount", {
                applied_promo_disc_amt: currentObj.applied_promo_disc_amt,
              });

              currentObj.$store.dispatch("saveCoupanCodeID", {
                coupon_code_name: currentObj.coupan_code_id,
              });
              currentObj.$store.dispatch("saveCoupanCodeType", {
                applied_promo_disc_amt: currentObj.coupon_code_type,
              });

              // alert(currentObj.applied_promo_disc_amt);
              //currentObj.$refs.sidebar.hide();
            }
          })
          .catch((error) => {
            //this.errorMessage = error.message;
            alert("There was an error! " + error);
          });
      } else {
        //alert("User Not Logged In")
        // this.openModal()

        if (this.digital_order_setting.login_method == 1) {
          localStorage.setItem("formname", "loginwithotp");
          this.openModal();
          if (screen.width < 1366) {
            this.closeCart();
          }
        } else {
          localStorage.setItem("formname", "loginwithpassword");
          this.openModal();
          if (screen.width < 1366) {
            this.closeCart();
          }
        }
      }
    },
    removePromoCode () {
      //  alert("Hello")
      this.applied_promo_disc_amt = 0;
      this.coupon_code_name = "";
      this.coupon_code_type = "";
      this.coupan_code_id = "";
      this.coupan_code_amt = "";
      this.promo_code_ent = "";

      this.$store.dispatch("saveCoupanCodeName", {
        coupon_code_name: "",
      });
      this.$store.dispatch("saveCoupanCodeAmount", {
        applied_promo_disc_amt: 0,
      });

      this.$bvToast.toast("Applied discount removed", {
        variant: "danger",
        toaster: "b-toaster-bottom-left",
        solid: true,
      });
    },
    payNow () {
      /*     let MERCHANT_KEY = 'jYnXas'
let MERCHANT_SALT = 'dX4UXXBZ'
//let AUTHORIZATION_HEADER = 'vMQmCZOcfDib9dg7wLHvxts0sC+a+zCD2HN50Sl27cc='
let txnid = "tmbill@123"
let amount = "1"
let productinfo = "Bill Payment"
let firstname = "Vaibhav"
let email = "demo@gmail.com"

//var jsSHA = require("jssha");

var string = MERCHANT_KEY +'|' +txnid+ '|' +amount+'|'+productinfo+'|'+firstname+'|'+email+'|||||||||||'+MERCHANT_SALT;*/

      /*var sha = new jsSHA('SHA-512', "TEXT");         
sha.update(string)         
var hash = sha.getHash("HEX");  */
      //res.send({ 'hash': hash });

      /* var payumoney = require('payumoney-node');
payumoney.setKeys(MERCHANT_KEY, MERCHANT_SALT, AUTHORIZATION_HEADER);


payumoney.isProdMode(false); // production = true, test = false

            var paymentData = {
                productinfo: "Food Items like pizza, butter naan, garlic naan",
                txnid: "tmbill@123",
                amount: "1",
                email: "tmbill@gmail.com",
                phone: "8830427223",
                lastname: "Solaskar",
                firstname: "Vaibhav",
                surl: "", //"http://localhost:3000/payu/success"
                furl: "", //"http://localhost:3000/payu/fail"
            };

        payumoney.makePayment(paymentData, function(error, response) {
  if (error) {
    // Some error

    console.log(error)
  } else {
    // Payment redirection link
    console.log(response);
  }
});*/

      /*
            var RequestData = {
                        key: MERCHANT_KEY,
                        txnid: txnid,
                        hash: string,
                        amount: amount,
                        firstname: firstname,
                        phone: "8830427223",
                        email: email,
                        productinfo: productinfo,
                        surl: 'https://tmdigi:3000/digimenu/888',
                        furl: 'https://tmdigi:3000/digimenu/error',
                        // mode: 'dropout'// non-mandatory for Customized Response Handling
                    }

                    var Handler = {
                        responseHandler: this.onPayumoneyresponsehandler,
                        catchException: function (BOLT) {
                            console.error(BOLT);
                            // the code you use to handle the integration errors goes here
                        }
                    }
                    window.bolt.launch(RequestData, Handler);

*/

      /*
            let MERCHANT_KEY = 'jYnXas'
            let MERCHANT_SALT = 'dX4UXXBZ'
            let PAYUMONEY_AUTHORIZATION_HEADER = 'vMQmCZOcfDib9dg7wLHvxts0sC+a+zCD2HN50Sl27cc='

            var payUMoney = require('payumoney_nodejs');
            payUMoney.setProdKeys(MERCHANT_KEY, MERCHANT_SALT, PAYUMONEY_AUTHORIZATION_HEADER);
            payUMoney.setSandboxKeys(MERCHANT_KEY, MERCHANT_SALT, PAYUMONEY_AUTHORIZATION_HEADER);

            payUMoney.isProdMode(false); //set false for use of sandbox mode



              var requestBody = {
      "firstname" : "Vaibhav",
      "lastname" : "Solaskar",
      "email" : "vsolaskar72@gmail.com",
      "phone" : "9876543210",
      "amount" : 1,
      "productinfo" : "Food Items",
      "txnid" : "tmbill@123", //generate unqiue transaction Id at client/server side
      "surl" : "http:localhost:8080/payment/success",
      "furl" : "http:localhost:8080/payment/failure"
    };
  
  payUMoney.pay(requestBody, function(error, response) {
      if (error) {
        // Some error console.log(response);
      } else {
        // You will get a link in response to redirect to payUMoney
       //callback(null, { 'payulink' : response });

       console.log(response)
      }
    });
*/

      let MERCHANT_KEY = "jYnXas";
      let MERCHANT_SALT = "dX4UXXBZ";
      //let AUTHORIZATION_HEADER = 'vMQmCZOcfDib9dg7wLHvxts0sC+a+zCD2HN50Sl27cc='
      let txnid = "tmbill@123";
      let amount = "1";
      let productinfo = "Bill Payment";
      let firstname = "Vaibhav";
      let email = "demo@gmail.com";
      //let lastname = "Solaskar"
      let phone = "9876543210";

      var string =
        MERCHANT_KEY +
        "|" +
        txnid +
        "|" +
        amount +
        "|" +
        productinfo +
        "|" +
        firstname +
        "|" +
        email +
        "|||||||||||" +
        MERCHANT_SALT;

      var crypto = require("crypto");
      //var now= (new Date()).valueOf().toString();
      //var random = Math.random().toString();
      var hash = crypto.createHash("sha1").update(string).digest("hex"); //this is your unique hash

      //console.log(string)
      console.log("Hash is " + hash);

      var RequestData = {
        key: MERCHANT_KEY,
        txnid: txnid,
        hash: hash,
        amount: amount,
        firstname: firstname,
        email: email,
        phone: phone,
        productinfo: productinfo,
        surl: "http://localhost:8080/",
        furl: "http://localhost:8080/",
      };

      var Handler = {
        responseHandler: function (BOLT) {
          console.log("Response is " + JSON.stringify(BOLT));
        },
        catchException: function (BOLT) {
          console.log("Exception is " + JSON.stringify(BOLT));
        },
      };
      window.bolt.launch(RequestData, Handler);
    },
    gotoCheckout () {
      // alert("Hello")

      // alert(this.getCoupanAmount);

      localStorage.setItem("coupan_discount", this.getCoupanAmount);
      localStorage.setItem("coupon_code_name", this.getCoupanName);
      localStorage.setItem("coupon_code_type", this.getCoupanType);
      localStorage.setItem("coupan_code_id", this.getCoupanID);

      // currentObj.coupon_code_name = response.data.msg.coupan_code
      //console.log("coupon code is "+currentObj.coupon_code)
      //   currentObj.coupon_code_type = response.data.msg.per_fixed
      //   let promo_amt = response.data.msg.amount
      //   currentObj.coupan_code_id = response.data.msg.code_id

      //alert("userinfo in checkout button "+JSON.stringify(localStorage.getItem('userinfo')))

      this.userinfolocal = localStorage.getItem("userinfo")
        ? JSON.parse(localStorage.getItem("userinfo"))
        : [];

      // console.log("userinfolocal in checkout button "+JSON.stringify(this.userinfolocal))

      if (this.userinfolocal != "") {
        this.$router.push("/checkout").catch(() => { });
      } else {
        //alert("User Not Logged In")

        if (this.digital_order_setting.login_method == 1) {
          localStorage.setItem("formname", "loginwithotp");
          this.openModal();
          if (screen.width < 1366) {
            this.closeCart();
          }
        } else {
          localStorage.setItem("formname", "loginwithpassword");
          this.openModal();
          if (screen.width < 1366) {
            this.closeCart();
          }
        }
      }
    },
    open_well_cart () {
      // alert("Hello")

      this.$store.dispatch("saveCartStatus", {
        cart_stat: "open_cart",
      });
    },
    closeCart () {
      //  alert("Hello")
      this.$store.dispatch("saveCartStatus", {
        cart_stat: "close_cart",
      });
    },
    convertDate (ord_date) {
      var d = new Date(ord_date);

      //  alert(ord_date)
      //  d.getTime()
      //var date = new Date(ord_date);
      // var dt = d.getDay()+'-' +  d.getFullYear()+'-' + (d.getMonth()+1) + '-'+d.getDate();//prints expected format.
      var dt =
        d.getUTCFullYear() +
        "-" +
        (d.getUTCMonth() + 1) +
        "-" +
        d.getUTCDate() +
        " " +
        d.getHours() +
        ":" +
        d.getMinutes() +
        ":" +
        d.getSeconds();
      //   alert(dt)

      var newdt = new Date(dt);

      return newdt.toDateString();
    },
    removePrmoCodeCartItemChange () {
      // alert("Changed")

      this.currentItemCount = this.cartItemCount;

      this.removePromoCode();

      /*  this.boxTwo = ''
        this.$bvModal.msgBoxConfirm('Please confirm that you want to change cart items. If you change the cart items then discount will be removed', {
          title: 'Please Confirm',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          centered: true
        })
          .then(value => {
            this.boxTwo = value

           // alert("value is "+value)

            if(value) {
                
                this.currentItemCount = this.cartItemCount

                this.removePromoCode()
            }
            else {
// An error occurred
                this.currentItemCount = this.cartItemCount
            }
          })
          .catch(err => {
            // An error occurred
            err
          })*/
    },
    convertDateForPromo (date_of_promo) {
      var d = new Date(date_of_promo);

      var dt =
        d.getUTCFullYear() + "-" + (d.getUTCMonth() + 1) + "-" + d.getUTCDate();

      return dt;
    },
  },
  created () {
    this.getMenuItems();

    // alert(this.cartItems.length)
    if (this.cartItems.length == 0) {
      // this.$router.push("/").catch(()=>{});
    }

    //alert(JSON.stringify(this.outletInformation))
  },
  mounted () {
    //  alert("userinfo is "+JSON.stringify(localStorage.getItem('userinfo')))
    // this.userinfolocal = JSON.parse(localStorage.getItem('userinfo'))
    this.filterChanged(this.deliverytype);
    //  this.open_close_cart = 'close_cart'
  },
  updated () {
    //alert("Update in Cart Comp")

    if (
      this.coupan_code_amt > 0 &&
      this.cartItemCount != this.currentItemCount &&
      this.currentItemCount > 0
    ) {
      //alert("cartItemCount "+this.cartItemCount)
      //alert("currentItemCount "+this.currentItemCount)
      this.removePrmoCodeCartItemChange();
    } else {
      this.currentItemCount = this.cartItemCount;
    }
  },
};
</script>

<style>
.close_cart {
  right: -100%;
}

.open_cart {
  right: 0;
}

.Dm4hT {
  position: relative;
  padding-bottom: 40px;
  display: block;
}

._3Um38 {
  border: 1px solid #d4d5d9;
  padding: 0;
  display: block;
  position: relative;
  transform: translateZ(0);
}

._1oTLG::placeholder {
  color: #a9abb2;
}

._381fS::placeholder {
  color: #a9abb2;
}

._2x3kD {
  width: calc(100% - 110px);
}

._1oTLG {
  height: 50px;
  padding-top: 0;
  font-size: 1.15rem;
}

._1oTLG::placeholder {
  color: #a9abb2;
}

._381fS::placeholder {
  color: #a9abb2;
}

element {}

._2x3kD {
  width: calc(100% - 110px);
}

._1oTLG {
  height: 50px;
  padding-top: 0;
  font-size: 1.15rem;
}

._381fS {
  background-color: transparent;
  line-height: normal;
  border: none;
  outline: none;
  height: 50px;
  width: 100%;
  font-size: 17px;
  margin: 0;
  padding: 0 20px;
  padding-top: 0px;
  padding-top: 0px;
  box-shadow: none;
  box-sizing: border-box;
  border-radius: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
}

._26LFr {
  -ms-transform: translateY(70%);
  transform: translateY(70%);
}

._2EeI1 {
  position: absolute;
  right: 20px;
  bottom: 26px;
  font-size: 14px;
  font-weight: 500;
  color: #5d8ed5;
  transform: translateZ(0);
  cursor: pointer;
  will-change: transform;
  transition: 0.2s ease;
}

._2tL9P {
  font-size: 12px;
  font-weight: 500;
  color: #7e808c;
  -ms-transform: translateY(-70%);
  transform: translateY(-70%);
}

._1Cvlf {
  position: absolute;
  left: 0;
  bottom: 24px;
  padding-left: 20px;
  line-height: 20px;
  font-size: 17px;
  cursor: text;
  transition: 0.2s ease;
  width: 100%;
  color: #93959f;
  will-change: transform, color, font-size;
  pointer-events: none;
  font-weight: 400;
}

._3keqX {
  position: absolute;
  top: 1px;
  right: 0;
  width: 110px;
  background: #ffbb0e;
  color: #fff;
  height: 50px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  cursor: pointer;
  font-weight: 600;
}

._3HIZ1 {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
}

._3sxJM {
  position: relative;
  min-height: calc(100vh - 200px);
}

._1p3XG {
  border: 1px solid #ffbb0e;
  padding: 10px 0 0px 30px;
  margin-bottom: 13px;
  box-shadow: 1px 0px 3px #ffbb0e;
}

._1aSpx {
  color: #7e808c;
  font-weight: 600;
  margin: 0 0 28px;
  font-size: 15px;
  text-transform: uppercase;
  text-align: center;
}

.KVykS {
  position: relative;
  padding-bottom: 10px;
}

._2fpj9,
._3x0ey {
  display: -ms-flexbox;
  display: flex;
}

._2Vb6W {
  margin-bottom: 15px;
}

._2fpj9,
._3x0ey {
  display: -ms-flexbox;
  display: flex;
}

._2fpj9 {
  min-width: 105px;
  height: 35px;
  border: 2px solid #ffbb0e;
  background-color: #ffbb0e;
  -ms-flex-align: center;
  align-items: center;
}

._33BbS {
  margin-left: 10px;
  margin-right: 10px;
}

._2prG7 {
  font-size: 1.5rem;
  font-weight: 700;
  height: 100%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-positive: 1;
  flex-grow: 1;
  position: relative;
  padding: 0 15px;
  color: #fff;
}

._3AmpP::after {
  top: -2px;
  border: 5px solid transparent;
  border-top-color: transparent;
  border-top-style: solid;
  border-top-width: 5px;
  border-top: 5px solid #fff;
}

._3AmpP::after,
._3AmpP::before {
  content: "";
  position: absolute;
  left: 0;
  box-sizing: border-box;
  width: 10px;
  height: 10px;
}

._3AmpP::before {
  top: 0;
  border: 5px solid transparent;
  border-top-color: transparent;
  border-top-style: solid;
  border-top-width: 5px;
  border-top: 5px solid #daceb7;
}

._3ohAi::after {
  bottom: -2px;
  border: 5px solid transparent;
  border-bottom-color: transparent;
  border-bottom-style: solid;
  border-bottom-width: 5px;
  border-bottom: 5px solid #fff;
}

._3ohAi::after,
._3ohAi::before {
  content: "";
  position: absolute;
  left: 0;
  box-sizing: border-box;
  width: 10px;
  height: 10px;
}

._3ohAi::before {
  bottom: 0;
  border: 5px solid transparent;
  border-bottom-color: transparent;
  border-bottom-style: solid;
  border-bottom-width: 5px;
  border-bottom: 5px solid #daceb7;
}

.v0d5B {
  color: #3e4152;
  font-size: 1.5rem;
  font-weight: 700;
}

.mFwvW {
  color: #686b78;
  font-size: 1.4rem;
  margin-top: 9px;
}

.rteNN {
  position: relative;
}

.CYLGD {
  margin-top: 8px;
}

.QHG0M {
  overflow: hidden;
  transition: height 0.3s ease-out;
}

._3lKvf {
  font-size: 0.92rem;
  color: #686b78;
}

._2eryw {
  font-weight: 500;
}

.B9haR {
  margin-top: 15px;
}

._28V8H::before {
  position: absolute;
  content: "";
  height: 5px;
  width: 5px;
  background-color: #282c3f;
  top: 5px;
  left: 4px;
  border-radius: 50%;
}

._1Gp4i {
  margin-top: 0 !important;
}

._3LVhJ {
  padding-left: 0 !important;
}

.WybuQ {
  border: 0;
  background-color: transparent;
  color: #5d8ed5;
  font-size: 0.85rem;
  font-weight: 700;
  height: 28px;
  width: 88px;
  padding-left: 10px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 12px;
  outline: none;
  cursor: pointer;
}

._3dmIW {
  margin-top: 15px !important;
}

._1KzVF {
  width: 100%;
  text-decoration: none;
  display: inline-block;
  text-align: center;
  border: none;
  line-height: 50px;
  font-size: 14px;
  height: 50px;
  padding: 0 2rem;
  color: #ffbb0e;
  letter-spacing: 0;
  border: 1px solid #ffbb0e;
  margin-top: 26px;
  line-height: 36px;
  width: auto;
  height: 36px;
  padding: 0 15px;
  outline: none;
  min-width: 120px;
  background: #fff;
}

._1KzVF,
._2lope {
  font-weight: 600;
  cursor: pointer;
}

::-moz-focus-inner {
  border: none;
  border-top-style: none;
  border-right-style: none;
  border-bottom-style: none;
  border-left-style: none;
  outline: none;
}

[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner,
button::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

._2eFfS {
  border: 1px dashed #535665;
  padding: 0 15px;
  margin: 18px 0;
  color: #686b78;
  font-size: 12px;
  display: flex;
  align-items: center;
  height: 55px;
  box-shadow: 5px 5px 5px #535665;
  border-radius: 5px;
  width: 127%;
}

._2ksRx {
  -ms-flex: 1;
  flex: 1;
}

._2CuZt {
  color: #f5c464;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 700;
}

.jO5AL {
  margin-top: 2px;
  font-size: 12px;
  color: #93959f;
}

._1cXUn {
  text-transform: uppercase;
  cursor: pointer;
  margin-left: 8px;
  font-weight: 600;
  color: #282c3f;
  font-size: 14px;
}

@media (max-width: 768px) {
  ._2eFfS {
    width: 160%;
  }
}

@media (max-width: 640px) {
  ._2eFfS {
    width: 160%;
  }

  .show_promo_c90e_btn {
    width: 155%;
  }
}

@media (max-width: 480px) {
  ._2eFfS {
    width: 160%;
  }

  .show_promo_c90e_btn {
    width: 155%;
  }
}

@media (max-width: 320px) {
  ._2eFfS {
    width: 160%;
  }

  .show_promo_c90e_btn {
    width: 155%;
  }
}

@media screen and (min-width: 320px) {}

@media screen and (min-width: 960px) {}

@media all and (max-width: 360px) {
  ._2eFfS {
    width: 160%;
  }
}

@media all and (min-width: 361px) and (max-width: 414px) {
  ._2eFfS {
    width: 160%;
  }
}

.btn .btn-secondary .btn-sm {
  color: #fff;
  background-color: #c9302c;
  border-color: #ac2925;
  color: #fff !important;
}

button[class*="btn"] {
  /*color: #fff;*/
}

.btn:hover,
.btn:focus,
.btn.focus {
  text-decoration: none;
}
</style>